import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const pageList = (page, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const set = new Set([1, total, page - 1, page, page + 1]);
  const nums = [...set].filter(n => n >= 1 && n <= total).sort((a, b) => a - b);
  return nums.flatMap((n, i) => (i > 0 && n - nums[i - 1] > 1 ? ['…', n] : [n]));
};

export const Pagination = ({ page, pageSize, total, onPage, onPageSize, sizes = [10, 25, 50, 100], label = 'orders' }) => {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total ? (page - 1) * pageSize + 1 : 0;
  const to = Math.min(total, page * pageSize);
  const btn = 'min-w-[34px] h-[34px] px-2 rounded-md text-[13px] border transition-colors disabled:opacity-40 disabled:cursor-not-allowed';
  return (
    <div data-testid="pagination" className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-neutral-200 dark:border-neutral-800">
      <div className="flex items-center gap-3 text-[12.5px] text-neutral-500">
        <span data-testid="pagination-range">Showing {from}–{to} of {total} {label}</span>
        <label className="inline-flex items-center gap-1.5">
          Per page
          <select data-testid="pagination-size" value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))}
            className="bg-white dark:bg-[#141416] border border-neutral-200 dark:border-neutral-700 rounded-md px-2 py-1 text-[12.5px] outline-none">
            {sizes.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
      </div>
      <nav className="flex flex-wrap items-center gap-1" aria-label="Pagination">
        <button data-testid="pagination-prev" disabled={page <= 1} onClick={() => onPage(page - 1)} className={`${btn} border-neutral-200 dark:border-neutral-700 inline-flex items-center gap-1`}><ChevronLeft size={14} /> Prev</button>
        {pageList(page, pages).map((n, i) => (n === '…'
          ? <span key={`e${i}`} className="px-1.5 text-neutral-400">…</span>
          : <button key={n} data-testid={`pagination-page-${n}`} onClick={() => onPage(n)} aria-current={n === page ? 'page' : undefined}
            className={`${btn} ${n === page ? 'bg-neutral-900 text-white border-neutral-900 dark:bg-white dark:text-neutral-900 dark:border-white' : 'border-neutral-200 dark:border-neutral-700 hover:border-neutral-400'}`}>{n}</button>))}
        <button data-testid="pagination-next" disabled={page >= pages} onClick={() => onPage(page + 1)} className={`${btn} border-neutral-200 dark:border-neutral-700 inline-flex items-center gap-1`}>Next <ChevronRight size={14} /></button>
      </nav>
    </div>
  );
};
